var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolfinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9964 19.631C7.78853 19.631 4.36523 16.2072 4.36523 11.9986C4.36523 7.79007 7.78853 4.36621 11.9964 4.36621C16.2043 4.36621 19.6276 7.79007 19.6276 11.9986C19.6276 16.2072 16.2043 19.631 11.9964 19.631Z",
    fill: "#88F231"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7212 16.4046C11.687 16.4046 11.6521 16.4005 11.6179 16.3911C11.4415 16.3449 11.3182 16.1853 11.3182 16.0022V13.1055H9.61154C9.46669 13.1055 9.33322 13.0276 9.26149 12.9016C9.18972 12.7755 9.19176 12.6206 9.26619 12.4965L12.0732 7.79497C12.1658 7.63936 12.3508 7.56492 12.5252 7.61323C12.7002 7.66149 12.8209 7.81976 12.8209 8.00086V10.911H14.3861C14.5296 10.911 14.6623 10.9874 14.7341 11.1115C14.8065 11.2349 14.8071 11.3878 14.7361 11.5126L12.0706 16.2013C11.9981 16.3294 11.8627 16.4046 11.7212 16.4046Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90676 6.23892C6.01405 6.12557 6.1247 6.01491 6.23802 5.9076L5.26099 4.92974C5.16912 4.83852 5.02093 4.83852 4.92973 4.92974C4.83853 5.02095 4.83853 5.16984 4.92973 5.26105L5.90676 6.23892Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.093 6.23892L19.0707 5.26105C19.1619 5.16917 19.1619 5.02095 19.0707 4.92974C18.9795 4.83852 18.8306 4.83852 18.7394 4.92974L17.7617 5.9076C17.8751 6.01491 17.9857 6.12557 18.093 6.23892Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 3.60965C12.0762 3.60965 12.154 3.61099 12.2318 3.613V2.23407C12.2318 2.10463 12.1265 2 11.9977 2C11.8683 2 11.7637 2.1053 11.7637 2.23407V3.613C11.8415 3.61099 11.9193 3.60965 11.9977 3.60965Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60939 11.9997C3.60939 11.9212 3.61073 11.8434 3.61274 11.7656H2.23403C2.10461 11.7656 2 11.8709 2 11.9997C2 12.1291 2.10528 12.2338 2.23403 12.2338H3.61274C3.61073 12.156 3.60939 12.0782 3.60939 11.9997Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 20.391C11.9193 20.391 11.8415 20.3897 11.7637 20.3877V21.7666C11.7637 21.8961 11.869 22.0007 11.9977 22.0007C12.1272 22.0007 12.2318 21.8961 12.2318 21.7666V20.3877C12.154 20.3897 12.0762 20.391 11.9977 20.391Z",
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7635 11.7656H20.3848C20.3868 11.8434 20.3881 11.9219 20.3881 11.9997C20.3881 12.0775 20.3868 12.156 20.3848 12.2338H21.7635C21.8929 12.2338 21.9975 12.1285 21.9975 11.9997C21.9975 11.8702 21.8929 11.7656 21.7635 11.7656Z",
    fill: "#161616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.093 17.7627C17.9857 17.876 17.8751 17.9867 17.7617 18.094L18.7394 19.0719C18.7857 19.1175 18.8454 19.1403 18.9057 19.1403C18.9654 19.1403 19.0258 19.1175 19.0714 19.0719C19.1626 18.9806 19.1626 18.8318 19.0714 18.7405L18.093 17.7627Z",
    fill: "#161616"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90743 17.7627L4.92973 18.7399C4.83853 18.8318 4.83853 18.98 4.92973 19.0712C4.97533 19.1168 5.03568 19.1396 5.09536 19.1396C5.15571 19.1396 5.21539 19.1168 5.26166 19.0712L6.23936 18.0934C6.12537 17.9867 6.01472 17.876 5.90743 17.7627Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolfinLogo);
export default __webpack_public_path__ + "static/media/solfin-logo.42d6e600ecf3df4d4a19aa169d3a017d.svg";
export { ForwardRef as ReactComponent };